import angular from 'angular';

(function() {
    'use strict';

    angular.module('blocks.logger').factory('logger', logger);

    logger.$inject = ['$log', '$q', 'toastr', '$translate'];

    /* @ngInject */
    function logger($log, $q, toastr, $translate) {
        var service = {
            showToasts: true,

            error: error,
            info: info,
            success: success,
            warn: warn,
            // Juste la console
            log: $log.log
        };

        return service;
        /////////////////////

        function error(message, data, title, msgData, timeout) {
            if (timeout) {
                toastr.error($translate.instant(message, msgData), $translate.instant(title), { timeOut: timeout });
            } else {
                toastr.error($translate.instant(message, msgData), $translate.instant(title));
            }
            $log.error('Error: ' + message, data);
        }

        function info(message, data, title, msgData) {
            toastr.info($translate.instant(message, msgData), $translate.instant(title));
            $log.info('Info: ' + message, data);
        }

        function success(message, data, title, msgData) {
            toastr.success($translate.instant(message, msgData), $translate.instant(title));
            $log.info('Success: ' + message, data);
        }

        function warn(message, data, title, msgData) {
            toastr.warning($translate.instant(message, msgData), $translate.instant(title));
            $log.warn('Warning: ' + message, data);
        }
    }
})();
